import React, { useEffect } from "react";
import "./search-bar.m.css";
import { SearchBox } from "@quintype/components";
import Filter from "../../atoms/other-icons/Filter";
import Search from "../../atoms/other-icons/Search";

function SearchBar({ filterToggleHandler, defaultValue }) {
  const filterToggle = () => {
    filterToggleHandler(true);
  };

  const SearchIconTemplate = ({ children }) => (
    <div styleName="search-wrapper">
      {children}
      <button type="submit" styleName="search search-btn">
        <Search color="black" height="16px" width="16px" />
      </button>
      <button onClick={filterToggle} styleName="search" className="hide-desktop">
        <Filter color="black" height="18px" width="18px" />
      </button>
    </div>
  );

  useEffect(() => {
    window.onload = function () {
      document.querySelector("input").focus();
    };
  }, []);

  return (
    <SearchBox
      placeholder="ಇಲ್ಲಿ ಹುಡುಕಿ…"
      inputId="searchForm"
      inputClassName="search__form-input"
      template={SearchIconTemplate}
      initValue={defaultValue}
    />
  );
}

export default SearchBar;
